<template>
  <el-dialog :close-on-click-modal="false" title="发票配置" :visible.sync="visible" width="500px" @close="visible = false">
    <div>
      <div style="padding:0 0 20px 10px;display: flex;">
        <el-radio-group v-model="invoiceType">
          <el-radio :label="0">普通发票</el-radio>
          <el-radio :label="1">退税发票</el-radio>
        </el-radio-group>
      </div>

      <el-form :inline="true" label-position="left">
        <el-form-item label="发票抬头:" label-width="90px" required>
          <el-input maxlength='50' v-model="text" style="width: 340px"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div style="text-align: right;margin-right: 20px;">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { batchCreateInvoiceApi } from '@/apis/outStock'
export default {
  name: 'CreateInvoiceModal',
  props: ['clearSelect'],
  data() {
    return {
      text: '',
      visible: false,
      list: [],
      invoiceType: 0
    }
  },
  methods: {
    open(v) {
      this.text = ''
      this.list = v
      this.visible = true
    },
    ok() {
      if (!this.text) {
        this.$message.warning('请填写发票抬头')
        return
      }
      console.log(this.list)
      const params = {
        title: this.text,
        logisticsCodeList: this.list.map(v => v.logisticsCode),
        invoiceType: this.invoiceType
      }
      if (this.invoiceType === 0 && this.list.some(v => v.logisticsCustomerName?.includes('直行发'))) {
        this.$confirm('存在部分直行发主体发货的物流单，请确认', "提示", {
          confirmButtonText: "确认",
          type: "warning",
          cancelButtonText: "取消",
        }).then(() => {
          this.submitApi(params)
        });
        return
      }
      if (this.invoiceType === 1 && this.list.some(v => !v.logisticsCustomerName?.includes('直行发'))) {
        this.$confirm('存在部分非直行发主体发货的物流单，请确认', "提示", {
          confirmButtonText: "确认",
          type: "warning",
          cancelButtonText: "取消",
        }).then(() => {
          this.submitApi(params)
        });
        return
      }
      this.submitApi(params)
    },
    submitApi(params) {
      batchCreateInvoiceApi(params).then((res) => {
        if (!res.success) return
        this.$message.success('操作成功')
        this.visible = false
        this.clearSelect()
      })
    }
  }
}
</script>
